<script setup>
import SiteHeader from "./components/SiteHeader.vue";
import SiteFooter from "./components/SiteFooter.vue";
import ToastHost from "./components/ToastHost.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();
// The workspace brings its own shell; the public site gets the marketing chrome.
const isWorkspace = computed(() => route.path.startsWith("/workspace"));
</script>

<template>
  <a class="skip-link" href="#main">Skip to main content</a>
  <p class="sr-only" role="status" aria-live="polite" data-live-region></p>

  <SiteHeader v-if="!isWorkspace" />
  <main id="main" :class="isWorkspace ? 'ds-workspace-main' : 'ds-main'">
    <RouterView />
  </main>
  <SiteFooter v-if="!isWorkspace" />
  <ToastHost />
</template>
